import request from '@/utils/request'
export function GetWxLoginUrl(url) {
  return request({
    url: '/user/GetWxLoginUrl',
    method: 'get',
    params: { url }
  })
}
export function getEnumList() {
  return request({
    url: '/data/getEnumList',
    method: 'post'
  })
}

export function getStoreBase() {
  return request({
    url: '/data/getStoreBase',
    method: 'post'
  })
}
export function getUserBase() {
  return request({
    url: '/user/getUserBase',
    method: 'post'
  })
}
